import { SnackbarKey, SnackbarMessage, useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { getDialogInfo, selectChat } from '../../../redux/actions/chatsActions';

import { Avatar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { findChatById } from 'services/chat.sevice';
import { CHATS } from '../../../constants/routes';
import { useAppSelector } from '../../../hooks/hooks';
import useSecureDownload from '../../../hooks/useSecureDownload';
import { changeLocation } from '../../../redux/actions/authActions';
import ArrowSvg from '@icons/ArrowSvg';
import themeClasses from './styles.js';
import styles from './styles.module.scss';

const useStyles = makeStyles(themeClasses);

type ButtonProps = { id: SnackbarKey; message: SnackbarMessage };
interface ParsedMessage {
  img: string;
  userName: string;
  dialogId: number;
}

const getObjectFromString = (str: string): ParsedMessage => JSON.parse(str);

const NewMessage = React.forwardRef<HTMLDivElement, ButtonProps>(({ id, message }, ref) => {
  const { t } = useTranslation();
  const { closeSnackbar } = useSnackbar();
  const navigation = useHistory();
  const dispatch = useDispatch();
  const themeStyles = useStyles();
  const currentRoute = useAppSelector((state) => state.auth.currentRoute);
  const [isChatMode, setIsChatMode] = useState(false);
  const msg = getObjectFromString(message as string);
  const { img, userName, dialogId } = msg;
  const avatarLink = useSecureDownload(img);

  const chats = useAppSelector((state) => state.chats.chats);
  const chat = findChatById(chats, dialogId);

  const handleDismiss = () => {
    closeSnackbar(id);
    if (!isChatMode) {
      dispatch(changeLocation(CHATS));
      navigation.push(CHATS);
    }
    dispatch(selectChat(dialogId));
    dispatch(getDialogInfo(dialogId));
  };

  useEffect(() => {
    chat?.notificationsDisable && closeSnackbar(id);
  }, [chat, closeSnackbar, id]);

  useEffect(() => {
    if (currentRoute) {
      setIsChatMode(currentRoute.includes('chat'));
    }
  }, [currentRoute]);

  return (
    <div className={classNames(styles.container, themeStyles.block)} ref={ref} onClick={handleDismiss}>
      <Avatar alt={userName} src={avatarLink} className={themeStyles.userAvatar} />
      <div className={styles.contentWrapper}>
        <div className={styles.userNameWrapper}>
          <span>{userName}</span>
          <ArrowSvg direction="right" />
        </div>
        <span className={themeStyles.textLink}>{t('new.message')}</span>
      </div>
    </div>
  );
});

export default NewMessage;
